import React from 'react';
import { FaBoxOpen, FaTags, FaBook, FaCheckCircle } from 'react-icons/fa';
import { useTranslation } from '../../../shared/i18n';
import { GameHero, GameSection, ProductPriceCard, FAQAccordion, GallerySwiper, Footer } from '../../../shared/components';
import logoSvg from '../../../assets/logo-ya/logo.svg';
import * as S from './LogoYaProductPage.styles';

const LogoYaProductPage = () => {
  const t = useTranslation();

  const heroBadges = [
    { label: t('logoYaProduct.badges.type'), variant: 'secondary' },
    { label: t('logoYaProduct.badges.status'), variant: 'primary' },
  ];

  const galleryImages = [
    { alt: t('logoYaProduct.gallery.item1') },
    { alt: t('logoYaProduct.gallery.item2') },
    { alt: t('logoYaProduct.gallery.item3') },
  ];

  const includesItems = [
    { icon: <FaBoxOpen />, text: t('logoYaProduct.includes.item1') },
    { icon: <FaTags />, text: t('logoYaProduct.includes.item2') },
    { icon: <FaBook />, text: t('logoYaProduct.includes.item3') },
    { icon: <FaCheckCircle />, text: t('logoYaProduct.includes.item4') },
  ];

  const priceFeatures = t('logoYaProduct.price.features', { returnObjects: true }) || [];
  const faqItems = t('logoYaProduct.faq.items', { returnObjects: true }) || [];

  return (
    <S.PageContainer>
      <GameHero
        title={t('logoYaProduct.hero.title')}
        subtitle={t('logoYaProduct.hero.subtitle')}
        badges={heroBadges}
        image={logoSvg}
        imageAlt={t('logoYaProduct.hero.imageAlt')}
        actions={[
          {
            label: t('logoYaProduct.hero.whatsAppBtn'),
            href: `https://wa.me/59895454544?text=${encodeURIComponent(t('logoYaProduct.price.whatsAppMessage'))}`,
            variant: 'primary',
            external: true,
          },
        ]}
      />

      {/* Commercial Price & Reservation Section */}
      <GameSection
        title={t('logoYaProduct.price.title')}
        subtitle={t('logoYaProduct.price.subtitle')}
      >
        <S.PlaceholderBanner>
          {t('common.placeholderNote')}
        </S.PlaceholderBanner>

        <ProductPriceCard
          statusText={t('logoYaProduct.price.statusBadge')}
          priceText={t('logoYaProduct.price.amountText')}
          priceSubtext={t('logoYaProduct.price.amountSubtext')}
          features={Array.isArray(priceFeatures) ? priceFeatures : []}
          whatsAppUrl={`https://wa.me/59895454544?text=${encodeURIComponent(t('logoYaProduct.price.whatsAppMessage'))}`}
          whatsAppText={t('logoYaProduct.price.whatsAppBtn')}
          footerNote={t('logoYaProduct.price.footerNote')}
        />
      </GameSection>

      {/* What's Included */}
      <GameSection
        title={t('logoYaProduct.includes.title')}
        subtitle={t('logoYaProduct.includes.subtitle')}
        background="#ffffff"
      >
        <S.IncludesGrid>
          {includesItems.map((item, idx) => (
            <S.IncludeItem key={idx}>
              {item.icon}
              <S.IncludeText>{item.text}</S.IncludeText>
            </S.IncludeItem>
          ))}
        </S.IncludesGrid>
      </GameSection>

      {/* Product Gallery */}
      <GameSection
        title={t('logoYaProduct.gallery.title')}
        subtitle={t('logoYaProduct.gallery.subtitle')}
      >
        <GallerySwiper images={galleryImages} />
      </GameSection>

      {/* Commercial FAQ */}
      <GameSection
        title={t('logoYaProduct.faq.title')}
        subtitle={t('logoYaProduct.faq.subtitle')}
        background="#ffffff"
      >
        <FAQAccordion items={Array.isArray(faqItems) ? faqItems : []} />
      </GameSection>

      <Footer />
    </S.PageContainer>
  );
};

export default LogoYaProductPage;
